import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <div className="bg-yellow-500 text-black py-20">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl mb-4">Ready to Find Your Dream Home?</h2>
        <p className="text-xl max-w-2xl mx-auto mb-8">
          Schedule a site visit to Vasudharini Nest and experience the perfect blend of luxury and affordability
        </p>
        <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          {/* <Button to="/contact" variant="primary" size="lg">Book a Site Visit</Button> */}
          <Link to="/contact" className=' bg-black text-white px-5 py-3 rounded font-medium'>Contact Our Team</Link>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;